<template>
  
  <div>

    <section-background-image v-if="content.backgroundImage" :image="content.backgroundImage"></section-background-image>

    <div class="wrapper__inner--narrow">


      <section :class="pageCss" v-html="content.copy"></section>

    </div>

  </div>

</template>

<script>
  
  import SectionBackgroundImage from '@/components/Blocks/SectionBackgroundImage.vue';

  export default {
    name: 'SectionCopy',
    props: {
      content: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    computed: {
      pageCss() {
        return `content content__${this.content.type}`;
      }
    },
    components: {
      SectionBackgroundImage
    }
  };
</script>